// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"61":"fb631e3c","430":"52f01c07","823":"c8eae0fc"}[chunkId] + ".js";
};